import script from "./BiggestDiscountsVouchersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BiggestDiscountsVouchersPage.vue?vue&type=script&setup=true&lang=ts"

import "./BiggestDiscountsVouchersPage.vue?vue&type=style&index=0&id=31e86fe0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31e86fe0"]])

export default __exports__